import {createStore} from "redux";
import rootReducer from "./rootReducer";
import {composeWithDevTools} from 'redux-devtools-extension';

const store = createStore(rootReducer, /* preloadedState, */ composeWithDevTools(
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
));
export default store;
